module.exports = __webpack_public_path__ + "ed311c7a0ade9a75bb3ebf5a7670f31d.woff2";